import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class MessagesAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // GET MANY //
  getTotalsError() {
    let message = {
      body: 'MESSAGES_GET_TOTALS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  // ******************************
  //        Private methods
  // ******************************


}

angular
  .module('bringoz.admin.messages')
  .service('messagesAlertsService', MessagesAlertsService);
